import {useState, useEffect} from 'react';
import useAuthentication from 'hooks/useAuthentication.hook';
import NeoSpinner from 'design/design_components/neo/overlay/NeoSpinner.base';
import AdminRouter from 'routers/Admin.router';
import UnknownRouter from 'routers/Unknown.router';
import UnauthenticatedRouter from 'routers/Unauthenticated.router';
import { ChatContextProvider } from 'contexts/Chat.context';
import NeoDialogo from 'design/design_components/neo/overlay/NeoDialog.base';
import NeoButtonMain from 'design/design_components/neo/button/NeoButtonMain.base';
import AgentRouter from 'routers/Agent.router';
import SupervisorRouter from 'routers/Supervisor.router';
import useInfrastructure from 'hooks/useInfrastructure.hook';

export default function MainRouter() {
  const authentication = useAuthentication();
  const infrastructure = useInfrastructure();
  const [isAuthenticated, setIsAuthenticated] = useState();

  useEffect(async () => reboot(), [authentication.isAuthenticated()]);

  const reboot = async () => {
    const updatedIsAuthenticated = authentication.isAuthenticated();
    setIsAuthenticated(updatedIsAuthenticated);
  }

  return (<>
    {(infrastructure.statusSocket === 'CONNECTING') &&
      <NeoSpinner/>
    }

    {(infrastructure.statusSocket === 'ERROR') &&
      <NeoDialogo
        custom="socket-status"
        visible={true}
        closable={false}
        header="Error de conexión"
        footer={infrastructure.isLeader &&
          <NeoButtonMain
            label="Recargar"
            onClick={() => {window.location.reload()}}
            loading={false}
          />
        }
      >
        <p>Se ha perdido la conexión con el servidor</p>
        <p>Por favor, revisa tu conexión a internet e intenta nuevamente</p>
      </NeoDialogo>
    }

    {(isAuthenticated) === false &&
      <UnauthenticatedRouter/>
    }

    {(isAuthenticated && ['ADMIN', 'SUPERVISOR', 'AGENT'].includes(authentication.user.role) === false) &&
      <UnknownRouter/>
    }

    {(isAuthenticated && authentication.user.role === 'ADMIN') &&
        <AdminRouter/>
    }

    {(isAuthenticated && ['SUPERVISOR', 'AGENT'].includes(authentication.user.role)) &&
      <ChatContextProvider>
        {authentication.user.role === 'SUPERVISOR' && <SupervisorRouter/>}
        {authentication.user.role === 'AGENT' && <AgentRouter/>}
      </ChatContextProvider>
    }
  </>);
}